import { api } from '../../client';

export interface ProjectDto {
  id: string;
  project_name: string;
  client_id: string | null;
  client_name: string | null;
  project_type: string;
  status: string;
  start_date: string | null;
  end_date: string | null;
  budget: number;
  billing_method: string;
  description: string | null;
  revenue?: number;
  created_at?: string;
  updated_at?: string;
}

export interface ProjectStatsDto {
  total_projects: number;
  active_projects: number;
  total_budget: number;
  revenue: number;
}

export const projectsAllApi = {
  async list(
    search?: string
  ): Promise<{ data?: ProjectDto[]; stats?: ProjectStatsDto; message?: string; errors?: Record<string, string[]> }> {
    const q = search ? `?search=${encodeURIComponent(search)}` : '';
    try {
      return api.get(`/projects/all${q}`) as Promise<{
        data: ProjectDto[];
        stats: ProjectStatsDto;
      }>;
    } catch {
      return { data: [], stats: { total_projects: 0, active_projects: 0, total_budget: 0, revenue: 0 } };
    }
  },

  async get(id: string): Promise<{ data?: ProjectDto; message?: string }> {
    return api.get(`/projects/all/${id}`) as Promise<{ data: ProjectDto }>;
  },

  async create(data: {
    project_name: string;
    client_id?: string | null;
    project_type?: string;
    status?: string;
    start_date?: string | null;
    end_date?: string | null;
    budget?: number;
    billing_method?: string;
    description?: string | null;
  }): Promise<{ data?: ProjectDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/projects/all', data) as Promise<{
      data: ProjectDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async update(
    id: string,
    data: {
      project_name?: string;
      client_id?: string | null;
      project_type?: string;
      status?: string;
      start_date?: string | null;
      end_date?: string | null;
      budget?: number;
      billing_method?: string;
      description?: string | null;
    }
  ): Promise<{ data?: ProjectDto; message?: string; errors?: Record<string, string[]> }> {
    return api.put(`/projects/all/${id}`, data) as Promise<{
      data: ProjectDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async delete(id: string): Promise<{ success?: boolean; message?: string }> {
    return api.delete(`/projects/all/${id}`) as Promise<{ success?: boolean; message?: string }>;
  },
};

/** @deprecated Use projectsAllApi for All Projects sub-module */
export const projectsApi = projectsAllApi;
